import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import _ from 'lodash';
import { FormGroup, FormControl } from 'react-bootstrap';
import {
  Button,
} from '../../BaseComponent/Wrapper';

@translate([], { wait: true })
class SearchBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textValue: _.get(props, 'value', ''),
    };
    this.onChange = this.onChange.bind(this);
    this.clearText = this.clearText.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleSearchIcon = this.handleSearchIcon.bind(this);
  }
  onChange(event) {
    event.preventDefault();
    const value = _.get(event, 'target.value', '');
    if (value.length <= this.props.limitSearchingChars) {
      this.setState({
        textValue: value,
      });

      if (this.props.onChange) {
        this.props.onChange(value);
      }
    }
  }
  clearText(event) {
    event.preventDefault();
    this.setState({
      textValue: '',
    });
    if (this.props.onCancel) {
      this.props.onCancel('');
    }
  }
  handleKeyPress(event) {
    if (event.key === 'Enter') {
      if (this.props.onEnter) {
        this.props.onEnter(this.state.textValue.trim());
      }
    }
  }
  handleSearchIcon() {
    if (this.props.onEnter) {
      this.props.onEnter(this.state.textValue.trim());
    }
  }
  render() {
    const classCSS = this.props.classCSS ? this.props.classCSS : '';
    return (
      <FormGroup className={`${classCSS} im-search-box`}>
        <FormControl
          onChange={this.onChange}
          onKeyPress={this.handleKeyPress}
          type="text"
          placeholder={_.get(this.props, 'placeholder', 'Search')}
          value={this.state.textValue}
          autoFocus={this.props.autoFocus}
        />
        <i
          className="fa fa-search search-icon"
          onClick={this.handleSearchIcon}
        />
        {
          this.props.disableRemoveIcon ? '' : (
            <Button
              className="btn-cancel"
              onClick={this.clearText}
            >
              <span>{this.props.t(`default:Cancel`)}</span>
            </Button>
          )
        }
      </FormGroup>
    );
  }
}

SearchBox.propTypes = {
  placeholder: PropTypes.string,
  classCSS: PropTypes.string,
  onEnter: PropTypes.func,
  onCancel: PropTypes.func,
  disableRemoveIcon: PropTypes.bool,
  value: PropTypes.string,
  autoFocus: PropTypes.bool,
};
SearchBox.defaultProps = {
  autoFocus: false,
  disableRemoveIcon: false,
  limitSearchingChars: 80
};

export default (SearchBox);



// WEBPACK FOOTER //
// ./src/app/components/BaseComponent/Wrapper/SearchBox.js